var list = 'list_list__8wa721';
var listRightSlot = 'list_listRightSlot__8wa722';
var listRoot = 'list_listRoot__8wa720';

export { list, listRightSlot, listRoot };
//# sourceMappingURL=list.vanilla.mjs.map
